
/*
    Form for editing the location messages
*/

import React, { createRef } from "react";

import MainContext from "../MainContext";

import StyledCheckbox from "../Components/StyledCheckbox";
import DataItem from "../Components/DataItem";

import { updateLocationMessage } from "../Requests/MessageRequests";

import { scrollToRef } from "../Scripts/Utilities";

export default class MessagesLocationForm extends React.Component {

    static contextType = MainContext;

    constructor(){
        super();
        
        this.state = {
            message: "",
            fullscreen: null
        };

        this.focusRef = createRef();
    }

    componentDidMount(){
        // fill in the existing value
        this.setState({
            message: this.props.data.message,
            fullscreen: this.props.data.fullscreen === "true"
        }, () => {
            console.log("scroll to ref...", this.focusRef.current);
            // and scroll to put focus on the containing div
            scrollToRef(this.focusRef.current);
        });
    }

    updateValue = (evt) => {
        this.setState({[evt.target.name]: evt.target.value});
    }

    submit = () => {
        const request = () => updateLocationMessage({location: this.props.data.locationID,...this.state});
        const then = ({data}) => {
            if(data){
                this.context.sendNotification(false, `Location Message Updated for ${this.props.data.location}`);
                this.props.reload(this.props.close);
            }
            else{
                this.context.sendNotification(true, `Update location message failed, please try again`);
            }
        };

        this.context.runProcessing(request, then, "updateLocationMessage");
    }

    toggleFullscreen = () => {
        this.setState({fullscreen: !this.state.fullscreen});
    }

    render() {
        return (
            <div ref={this.focusRef} className="data-expanded" style={{
                padding: "8px"
            }}>
                <div>
                    <div className="form-element-horizontal">
                        <label>Location</label>
                        <div><DataItem val={this.props.data.displayName}/></div>
                    </div>

                    <div className="form-element-horizontal">
                        <label>Message</label>
                        <textarea name="message" value={this.state.message} rows="4" onChange={this.updateValue} />
                    </div>

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "12px"
                    }}>
                        <StyledCheckbox 
                            name="fullscreen" 
                            label="Fullscreen?"
                            checked={this.state.fullscreen} 
                            onChange={this.toggleFullscreen} 
                        />
                    </div>
                </div>
                <div className="option  " onClick={this.submit}>
                    SUBMIT
                </div>
            </div>
        )
    }
}